import React from 'react';
import {
	ITextProps,
	ITextStyles,
	TextCompat as Text,
} from 'components/FluentUICompat';

const styles: ITextStyles = {
	root: {fontWeight: 500},
};

export function KeywordTooltipHeading({
	children,
}: ITextProps): React.ReactElement {
	return (
		<Text as='h2' styles={styles}>
			{children}:
		</Text>
	);
}
